<template>
	<div class="score-board-wrap">
		<div ref="board" class="score-board">
			<div class="score-board-content">
				<div class="title">
					<span>打分板</span>
				</div>
				<div class="sel-ope" v-if="Number(this.originalStep) === 0">
					<div class="step-title">设置步长:</div>
					<el-select v-model="stepScore" placeholder="请选择" @change="changeSel">
						<el-option v-for="item in selOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
					</el-select>
				</div>
				<ul class="score-wrap">
					<li class="score-list" v-for="(item, index) in stepList" :key="index" @click="choseScore(item)">
						{{ item }}
					</li>
				</ul>
			</div>
		</div>
		<guide
			class="guide-band-score-board"
			v-if="guideStep === 9"
			title="打分板打分"
			distribute="快捷打分，有加分和减分两种方式，选取步长之后，点击试卷进行快捷打分，点击删除按钮，可对快捷打分删除"
			:isTopArr="false"
		/>
	</div>
</template>

<script>
import { mapActions } from 'vuex'
import dragMixin from '../../../mixin/drag-mixin'
import guideMixin from '../utils/guide-mixin'
export default {
	name: 'score-board',
	mixins: [dragMixin, guideMixin],
	components: { guide: () => import('./guide') },
	data() {
		return {
			//步长
			selOptions: [
				{ value: 0.5, label: '0.5分' },
				{ value: 1, label: '1分' },
				{ value: 1.5, label: '1.5分' },
				{ value: 2, label: '2分' },
				{ value: 3, label: '3分' },
				{ value: 4, label: '4分' },
				{ value: 5, label: '5分' },
				{ value: 10, label: '10分' }
			],
			//打分别表
			stepList: [],
			//得分列表
			scoreList: [],
			//图片
			imgAddrMarkList: [],
			//选中步长
			stepScore: 1,
			//最大值
			maxScore: 0,
			//当前选中
			currentIndex: 0,
			basicInfo: {},
			//是否自动提交
			isAutoSubmit: true,
			//开始时间
			startTime: 0,
			query: this.$route.query,
			//是否快捷打分
			isFastScoreState: false,
			//旋转
			horizontalChange: null,
			//初始的步长
			originalStep: null,
			//位置
			dragStartX: -40,
			dragStartY: 0,
			//是否历史状态
			isHistoryState: false,
			//旋转
			rotateDegree: 0,
			//缩放
			scaleState: 1,
			//阅卷类型
			examType: null,
			//阅卷类型
			examRemark: ''
		}
	},
	created() {
		this.examType = this.query.type
	},
	mounted() {
		this.watchEmitVal()
		this.getScreenWidth()
		this.$nextTick(() => {
			this.dragStartY = 285
			this.$refs['board'].style.transform = `translateX(${this.dragStartX}px) translateY(${this.dragStartY}px)`
		})
	},
	methods: {
		...mapActions('examination/databases', ['get', 'set']),
		//eventBus
		watchEmitVal() {
			this.eventBus.$on('isTypical', cb => {
				if (cb.state) {
					this.examType = 1
					this.examRemark = cb.text
				} else {
					this.examType = this.query.type
				}
			})
			this.eventBus.$on('emitScoreList', cb => (this.scoreList = cb))
			this.eventBus.$on('emitScoreCurrentIndex', cb => (this.currentIndex = cb))
			this.eventBus.$on('isAutoSubmitPage', cb => (this.isAutoSubmit = cb))
			this.eventBus.$on('basicInformation', cb => (this.basicInfo = cb))
			this.eventBus.$on('imgAddrListInfo', cb => (this.imgAddrMarkList = cb.imgAddrList))
			this.eventBus.$on('isFastScoreState', cb => (this.isFastScoreState = cb))
			this.eventBus.$on('horizontalChange', cb => (this.horizontalChange = cb))
			this.eventBus.$on('isHistoryState', cb => (this.isHistoryState = cb))
			this.eventBus.$on('startTime', cb => (this.startTime = cb))
			this.eventBus.$on('emitCurrentStepScore', async cb => {
				this.originalStep = cb.stepScore
				this.maxScore = cb.score

				if (this.isFastScoreState) {
					const pathKey = this.query.markingTaskId + this.scoreList[this.currentIndex].pkId
					const localSel = await this.get({ dbName: 'database', path: 'fastScoreStep.' + pathKey, user: true })
					this.stepScore = 1
					if (Number(cb.stepScore) > 0) {
						this.stepScore = cb.stepScore
					} else if (localSel && Number(cb.stepScore) === 0) {
						this.stepScore = localSel
					}
				}
				this.makeStep()
			})
		},
		// 屏幕宽度
		getScreenWidth() {
			if (window.screen.width <= 1920) {
				this.dragStartX = -350
			}
		},
		//根据步长生成打分列表
		makeStep() {
			let step = Number(this.stepScore)
			if (this.originalStep > 0) {
				step = this.originalStep
			}
			let list = []
			for (let i = 0; i < this.maxScore; i += step) {
				list.push(i)
			}
			list.push(this.maxScore)
			this.stepList = Array.from(list)
		},
		// 修改步长
		changeSel(step) {
			// const pathKey =
			// 	this.basicInfo.markingTaskId +
			// 	this.scoreList[this.currentIndex].pkId({ dbName: 'database', path: 'fastScoreStep.' + pathKey, value: this.stepScore, user: true })
			this.stepScore = step
			this.makeStep()
			this.eventBus.$emit('emitCurrentStepScore', this.scoreList[this.currentIndex])
		},
		//	打分
		choseScore(val) {
			this.scoreList[this.currentIndex].getScore = val
			this.eventBus.$emit('emitScoreList', this.scoreList)
			import('../utils/help').then(resp => {
				resp.isAllGetScore(this.scoreList).then(responce => {
					if (responce) {
						if (this.isHistoryState) return false
						if (this.isAutoSubmit) {
							let totalScore = 0
							this.scoreList.forEach(res => (totalScore += res.getScore))
							const duration = new Date().getTime() - this.startTime
							if (this.loadingState) return false
							const self = this
							this.loadingState = true
							this.eventBus.$emit('isDisableSubmitBtn', true)
							if (Number(this.basicInfo.studentId) < 0) {
								this.loadingState = false
								this.eventBus.$emit('isDisableSubmitBtn', false)
								this.$message({ type: 'error', message: '暂无试卷', duration: 3000 })
								return false
							}
							import('../utils/help').then(resp => {
								resp.submitScore(
									this,
									this.$route.query,
									this.scoreList,
									this.basicInfo,
									this.imgAddrMarkList,
									duration,
									this.examType,
									this.isFastScoreState,
									this.horizontalChange,
									this.examRemark
								).then(res => {
									if (res.code === '200') {
										setTimeout(() => {
											self.loadingState = false
											self.eventBus.$emit('isDisableSubmitBtn', false)
										}, 500)
										this.$bigScore({ score: totalScore, dom: this.$parent.$refs['home'] })
										this.eventBus.$emit('isTypical', { state: false })
										this.eventBus.$emit('flushData') // 重新获取下一条数据
									}
								})
							})
						} else {
							this.$message({ type: 'info', message: '请提交', duration: 3000 })
						}
					} else {
						// 自动跳转到下一个
						this.currentIndex += 1
						this.eventBus.$emit('emitScoreCurrentIndex', this.currentIndex)
						this.eventBus.$emit('emitCurrentStepScore', this.scoreList[this.currentIndex])
						this.eventBus.$emit('originStepScore', this.scoreList[this.currentIndex].stepScore)
					}
				})
			})
		}
	}
}
</script>

<style scoped lang="less">
.score-board {
	border-radius: 8px;
	background: white;
	box-shadow: 0 0 10px rgb(185, 180, 180);
	position: absolute;
	right: 0;
	top: 0;
	padding: 0 10px 0px;
	box-sizing: border-box;
	cursor: move;
	z-index: 5;
	transform: translateX(-430px);
	.score-board-content {
		width: 265px;
		max-height: 620px;
		overflow: auto;
		&::-webkit-scrollbar {
			width: 4px;
		}
		&::-webkit-scrollbar-track {
			width: 4px;
		}
	}
	@media screen and (max-width: 1920px) {
		transform: translateX(-350px);
	}
	&::-webkit-scrollbar {
		width: 1px;
	}
	.title {
		height: 35px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 16px;
		border-bottom: 1px solid #e6e6e6;
		margin-bottom: 15px;
		.iconfont {
			cursor: pointer;
			font-size: 15px;
		}
	}
	.sel-ope {
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: 18px;
		.step-title {
			width: 120px;
			font-size: 16px;
		}
	}
	.score-wrap {
		width: 100%;
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
		margin-top: 20px;
		.score-list {
			width: 75px;
			height: 30px;
			text-align: center;
			line-height: 30px;
			background: #009688;
			margin-right: 13px;
			margin-bottom: 15px;
			border-radius: 2px;
			color: white;
			font-size: 18px;
			cursor: pointer;
			&:active {
				background: #007571;
			}
			&:nth-child(3n) {
				margin-right: 0;
			}
		}
	}
}
</style>
